export default __webpack_public_path__ + "static/media/icon-signout.cd21eaf6.svg";